
import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'


const styles = theme => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    left: '50%',
    outline: 'none',
    padding: theme.spacing.unit * 4,
    position: 'absolute',
    textAlign: 'center',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '88%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 600
    },
    '& Button': {
      marginTop: 20
    },
    overflow: 'scroll',
  }
})

// Wrapper around Material-UI <Modal> to apply common styles.
const DcpModal = ({children, classes, styles={}, ...rest}) => (
  <Modal
    {...rest}
  >
    <div className={classes.paper} style={styles}>
      {children}
    </div>
  </Modal>
)

DcpModal.propTypes = {
  children: PropTypes.element.isRequired
}

export default withStyles(styles)(DcpModal)


// WEBPACK FOOTER //
// ./src/components/common/DcpModal.js